import React, { useMemo } from 'react'
import { graphql } from 'gatsby'
import styled from '@emotion/styled'

import type { WebformObject } from 'gatsby-drupal-webform'
import type { Paragraph, ParagraphComponent } from '../types'
import type { FieldLink } from '../../../drupal'

import Form from '../../ui/Form'
import Container from '../../Container'
import { widths } from '../../../styles/variables'

interface FormParagraph extends Paragraph {
	field_link: FieldLink
	relationships: {
		field_webform: WebformObject
	}
}

function renderWebform(paragraph: FormParagraph) {
	const Webform = useMemo(() => {
		if (paragraph.relationships.field_webform.drupal_internal__id === 'member') {
			const MemberForm = React.lazy(() => import('../../jaseneksi/MemberForm'))
			return <MemberForm language="fi" />
		}

		return (
			<Form
				webform={paragraph.relationships.field_webform}
				onSuccess={{ type: 'navigate', destination: paragraph.field_link.link || paragraph.field_link.uri }}
				sourceEntity={{
					entityType: 'paragraph',
					entityId: paragraph.drupal_internal__id
				}}
			/>
		)
	}, [paragraph])

	return Webform
}

const FormParagraphComponent: ParagraphComponent<FormParagraph> = ({ className, paragraph }) => (
	<Container className={className}>{renderWebform(paragraph)}</Container>
)

export default styled(FormParagraphComponent)`
	max-width: ${widths.md}px !important;
`

export const query = graphql`
	fragment FormParagraph on paragraph__form {
		drupal_internal__id
		field_link {
			title
			link
			uri
		}
		relationships {
			field_webform {
				...DrupalWebform
			}
		}
	}
`
